import { combineReducers } from 'redux';

import consultarCidadaoAutista from './consultarCidadaoAutista/reducer';
import cadastrarCidadaoAutista from './cadastrarCidadaoAutista/reducer';
import atualizarCidadaoAutista from './atualizarCidadaoAutista/reducer';

export default combineReducers({
	consultarCidadaoAutista,
	cadastrarCidadaoAutista,
	atualizarCidadaoAutista,
});
